module.exports = __webpack_public_path__ + "static/media/bg-desk-1@2x.dc72bd03.jpg";